module.exports = __webpack_public_path__ + "img/bio.0014b897.svg";